import React, { Fragment, useState, useEffect, useRef } from 'react';
import Header from './Header';
import Footer from './Footer';
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const AboutUs = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  useEffect(() => {
    document.title = 'About Us | KumbhaaTech Solutions';
    return () => {
      document.title = 'Leading Software Company - KumbhaaTech Solutions';
    };
  }, []);

  const sliderRef = useRef(null);

  // Slider settings
  const settings = {
    dots: false,
    infinite: true,
    speed: 1000,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true, // Enable auto slide
    autoplaySpeed: 3000, // 3 seconds per slide
    beforeChange: (current, next) => {
      setActiveIndex(next);
    },
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  // Data for the slider
  const cards = [
    {
      image: "assets/images/icons/Expertise and Experience.svg",
      heading: "Expertise and Experience",
      description: "Since our inception in 2015, we have consistently delivered high-quality services that exceed client expectations.",
    },
    {
      image: "assets/images/icons/affordable.svg",
      heading: "Affordable Prices",
      description: "We pride ourselves on offering premium services at cheap and affordable prices, ensuring great value for your investment.",
    },
    {
      image: "assets/images/icons/Client-Centric Approach.svg",
      heading: "Client-Centric Approach",
      description: "We prioritize understanding your unique needs and goals to provide tailored solutions that drive success.",
    },
    {
      image: "assets/images/icons/Proven Track Record.svg",
      heading: "Proven Track Record",
      description: "Our satisfied clients attest to our ability to deliver results, whether enhancing their online presence or excelling academically.",
    }
  ];

  // Navigation handlers for the custom arrows
  // const handlePrevious = () => {
  //   sliderRef.current.slickPrev();
  // };

  // const handleNext = () => {
  //   sliderRef.current.slickNext();
  // };
  return (
    <Fragment>
      <Header />
      <div className="custom-banner-1">
        <div className="container">
          <div className="custom-banner-content">
            <div className="left-content">
              <h1> Kumbhaatech Solutions<span className='red-g'> Elevating Your </span>Digital Presence
              </h1>
            </div>
            <div className="right-content">
              <hr
                className="orange-line"
                style={{ height: '5px', width: '50px', background: '#FF0000', opacity: '1' }}
              />
              <p>
                At Kumbhaatech Solutions, we specialize in delivering top-notch website design and content writing services that cater to your unique business needs. Our expert team is dedicated to creating visually stunning websites and compelling content that drive engagement and growth. Discover the perfect blend of creativity and affordability with Kumbhaatech Solutions
              </p>

            </div>
          </div>
        </div>
      </div>
      <section class="about-section" id='company' >
        <div class="container" >
          <div className='about-heading col-lg-7'>

            <h1 style={{ textAlign: 'left' }}>Kumbhaatech <span className=''>Solutions</span> Elevating Your Digital Presence</h1>
          </div>
          <br />
          <div class="about-container ">
            <div class="col-lg-5 about-img">
              <img src="assets/images/New folder/details-1.png" alt="About " />
            </div>
            <div class="col-lg-6 about-content">

              <p >Welcome to KumbhaaTech, your premier destination for comprehensive digital solutions. Founded in 2015, KumbhaaTech has emerged as a leading company in website design and development, software services, content writing, SOP writing for overseas education, and assignment writing services. Our commitment to delivering high-quality services at a low cost has set us apart in the industry, enabling us to build lasting relationships with our clients.</p>
              <p>At KumbhaaTech, we understand that in today's digital age, having a professional and well-designed website is no longer a luxury—it's a necessity. However, we also recognize that the cost of professional web design can be a significant barrier for many businesses. That’s why we offer affordable website design and development services that deliver exceptional value without breaking the bank. Our team of skilled designers and developers works closely with you to create websites that are not only visually appealing but also user-friendly and optimized for performance.</p>

              <br />
              <Link to='https://calendly.com/kumbhaatech/15min' target="_blank" rel="noopener noreferrer" className='abut-btn b-red'> Schedule a Consultation</Link>
            </div>
          </div>
        </div>
      </section>
      <section className='abt-why-choose' id='why' >
        <div className="container ">
          <div className=" col-lg-12 ">
            <div className='abt-content'>
              <h2 className='text-black' > Why you <span className=''>choose us?</span></h2>
              <br />
              <p className='text-black'>In today's digital age, having a website is essential, but the cost of professional web design can be prohibitive. At KumbhaaTech Solutions, we specialize in providing top-notch website design and development services at a low cost. Our expert team ensures you receive exceptional value without breaking the bank. Partner with us to elevate your online presence affordably. Ready to get started?</p>
            </div>
          </div>

        </div>

      </section>
      <section className='benefit-slider-section' id='benefits' >

        <div className="container">

          <div className="row">
            <div className="col-lg-12">
              <div className="slider-container digital">
                <Slider ref={sliderRef} {...settings}>
                  {cards.map((card, index) => (
                    <div className={`slider-card ${index === activeIndex ? 'active' : ''}`} key={index}>
                      <div className="slider-image">
                        <img
                          src={card.image}
                          alt={card.heading}

                          loading='lazy'
                          decoding='async'
                        />
                      </div>
                      <h4 className="h-hide">{card.heading}</h4>
                      <div className={`c-conetnt ${index === activeIndex ? 'show' : ''}`}>
                        <h4 className="card-heading">{card.heading}</h4>
                        <p className="card-description">
                          {card.description}
                        </p>
                      </div>
                    </div>
                  ))}
                </Slider>
                {/* 
                <div className="bottom-container">
                  <div className="custom-arrows">
                    <button className="custom-arrow" onClick={handlePrevious}>
                      &#8249;
                    </button>
                    <button className="custom-arrow" onClick={handleNext}>
                      &#8250;
                    </button>
                  </div>

                </div> */}
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className='key-module-red ' id='value'>

        <div class=" container">
          <div className='features-courseProject'>
            <div class="row">
              <div class="col-lg-12">
                <h2 className=' ab-h'>
                  Our <span className=''>Values</span>
                </h2>
              </div>

              <div class="key-modules-container ab-key">


                <div class="key-module ky-b">

                  <h3 className=''>Our Mission</h3>
                  {/* Illustration by <a href="https://icons8.com/illustrations/author/ZQDZn9ZZj5aQ">Violetta Barsuk</a> from <a href="https://icons8.com/illustrations">Ouch!</a> */}
                  <br />
                  <p>  Website design according to us is a spiritual process that lets us understand you, your work, and your need after which we contemplate the best template design over which we can build your website.
                    We have a single and unshakeable faith in our effort to produce the best for you</p>
                </div>

                <div class="key-module">

                  <h3>Privacy </h3>

                  <br />
                  {/* Illustration by <a href="https://icons8.com/illustrations/author/lZpGtGw5182N">Elisabet Guba</a> from <a href="https://icons8.com/illustrations">Ouch!</a> */}
                  <p>  Privacy is a top priority at kumbhatech, reflected in our robust data protection measures and adherence to strict privacy standards. We safeguard sensitive information to ensure trust, confidentiality, and peace of mind for our clients and partners.</p>
                </div>
                <div class="key-module">
                  {/*  <img src="assets/images/support-red.png" alt="" /> */}

                  <h3>Our Commitment</h3>
                  <br />
                  {/* Illustration by <a href="https://icons8.com/illustrations/author/eEbrZFlkyZbD">Anna A</a> from <a href="https://icons8.com/illustrations">Ouch!</a> */}
                  <p> At KumbhaaTech, we are dedicated to maintaining the highest standards of quality and excellence. We strive to build lasting relationships with our clients by providing outstanding service and continuous support. Our team works tirelessly to ensure every project is completed on time, within budget, and to your complete satisfaction.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section >

      {/*   <section style={{ marginTop: '50px' }} id='team'>
        <div className="container ">
          <div className=" col-lg-12 ">
            <h2 className="colour-blue" style={{ textAlign: 'center' }}>Founders</h2>

          </div>
          <div class="benefit-cards">

            <div class="benefit-card benefit-card2">
              <div className='benefit-inside'>
                <div class="benefit-image">
                  <img src="assets/images/kumbha logo.png" alt="Benefit Icon 4" />
                </div>
                <div className="team-conetent">

                  <h5>Mr.Hariharan V</h5>
                  <p>CEO & Founder</p>


                  <Link href="#"><i className="fa fa-linkedin"></i></Link>

                </div>
              </div>
            </div>
            <div class="benefit-card benefit-card2">
              <div className='benefit-inside'>
                <div class="benefit-image">
                <img src="assets/images/kumbha logo.png" alt="Benefit Icon 4" />
                </div>
                <div className="team-conetent">

                  <h5>Mrs. Iniya H</h5>
                  <p>Director & Founder</p>


                  <Link href="#"><i className="fa fa-linkedin"></i></Link>

                </div>
              </div>
            </div>
          </div>
        </div>

      </section>
      <section style={{ marginTop: '50px' }}>
        <div className="container">
        <TeamSlider />
        </div>
        <br />

      </section>
 */}

      <Footer />
    </Fragment>
  )
}

export default AboutUs;
